import { render, staticRenderFns } from "./HeaderPopup.vue?vue&type=template&id=bcf07394&scoped=true&"
import script from "./HeaderPopup.vue?vue&type=script&lang=js&"
export * from "./HeaderPopup.vue?vue&type=script&lang=js&"
import style0 from "./HeaderPopup.vue?vue&type=style&index=0&id=bcf07394&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcf07394",
  null
  
)

export default component.exports